<template>
	<form class="user-activation-form" @submit.prevent="submitForm">
		<errors-list :errors="errors"/>
		<default-field-box type="text" name="activation_code" :placeholder="$t('forms.activation_code')"
		                   v-model="activationCode" event="activation-code-changed" autocomplete="one-time-code" :required="true"/>
		<div class="form-actions">
			<button class="button style-4" :class="activateUserLoading ? 'loading' : ''">
				<span class="inner">{{ $t('auth.activate_account') }}</span>
			</button>
			<p>{{ $t('auth.code_not_received') }}</p>
			<button class="button style-1" :class="sendActivationCodeLoading ? 'loading' : ''"
			        @click.prevent="sendActivationCode">
				<span class="inner">
					{{ $t('auth.send_code_again') }} <span v-if="countdown">{{ $t('auth.send_code_again_suffix') }} </span>
					<span class="countdown" v-if="countdown">({{ countdown }})</span>
				</span>
			</button>
			<a href="#" class="link" @click.prevent="changePhone">{{ $t('auth.change_phone' )}}</a>
		</div>
	</form>
</template>

<script>
	import DefaultFieldBox from "../form-fields/DefaultFieldBox";
	import ErrorsList from "../containers/ErrorsList";
	import { trackEvent } from '@/analytics';

	export default {
		name: "UserActivationForm",
		components: {
			DefaultFieldBox,
			ErrorsList
		},
		data() {
			return {
				activationCode: '',
				errors: false,
				activateUserLoading: false,
				sendActivationCodeLoading: false,
				countdown: 0,
				interval: null,
			}
		},
		methods: {
			startCountdown() {
				if (this.countdown === 0) {
					this.countdown = 60; // 1 minute countdown
					this.interval = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
					} else {
						clearInterval(this.interval);
					}
					}, 1000);
				}
			},
			changePhone(){
				this.$emit('change-phone');
			},
			submitForm() {
				if (!this.activationCode) {
					return false;
				}

				this.activateUserLoading = true;
				trackEvent('form_submit', { form_name: 'user_activation', module: 'auth' });
				this.axios.post('/api/user/activate-account', {
					activation_code: this.activationCode,
				}).then(response => {
					this._submitSuccess = true;
					trackEvent('form_submit_success', { form_name: 'user_activation', module: 'auth' });
					this.$store.state.auth.user.active = 1;
					this.$store.commit('CLOSE_USER_ACTIVATION_POPUP');
					if (this.$store.state.auth.pendingAction) {
						this.$store.dispatch('processPendingAction', this.$store.state.auth.pendingAction);
					}
				}).catch(error => {
					trackEvent('form_submit_error', {
						form_name: 'user_activation',
						module: 'auth',
						error_message: error.response && error.response.data ? error.response.data.message : error.message,
						error_status: error.response ? String(error.response.status) : null,
					});
					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					} else {
						if (error.response.data.message) {
							this.errors = {error: [error.response.data.message]};
						}
					}

					this.activateUserLoading = false;
				});

			},
			sendActivationCode(e, showErrorMessage = true) {
				if(this.countdown){
					return;
				}

				this.sendActivationCodeLoading = true;
				this.axios.get('/api/user/send-activation-code').then((response) => {
					this.sendActivationCodeLoading = false;
					this.startCountdown();
				}).catch((error) => {
					this.sendActivationCodeLoading = false;

					if (!showErrorMessage) {
						return false;
					}

					this.$swal.fire({
						icon: 'error',
						title: 'Oops',
						text: error.response.data.message,
					});

					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					}
				});
			},
			checkValidActivationCode(){
				this.sendActivationCodeLoading = true;
				this.axios.get('/api/user/check-valid-activation-code').then((response) => {
					this.sendActivationCodeLoading = false;
					if(!response.data.valid_activation_code){
						this.sendActivationCode(null, false);
					} else {
						this.startCountdown();
					}
				}).catch((error) => {
					this.sendActivationCodeLoading = false;
					this.sendActivationCode(null, false);
				});

			},
			processActivationCodeChanged(data) {
				this.activationCode = data.value;
			}
		},
		mounted() {
			this._submitSuccess = false;
			trackEvent('form_open', { form_name: 'user_activation', module: 'auth' });
			this.$root.$on('activation-code-changed', (data) => {
				this.processActivationCodeChanged(data);
			});
			this.checkValidActivationCode(null, false);
		},
		beforeDestroy() {
			if (!this._submitSuccess) {
				trackEvent('form_close', { form_name: 'user_activation', module: 'auth' });
			}
		},
		destroyed() {
			this.$root.$off('activation-code-changed');
		}
	}
</script>

<style scoped lang="scss">
	.link {
		color: var(--font-color);
		&:hover {
			color: var(--white-color);
		}
	}
	.button {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}
</style>